import React from "react"

const LinkedIn = () => (
	<svg
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		className="inline-block fill-current align-middle">
		<path
			d="M3.454 8.772h3.508v12.227H3.454V8.772zm1.665-1.53h-.026C3.823 7.242 3 6.308 3 5.124 3 3.916 3.848 3 5.143 3c1.294 0 2.09.914 2.116 2.12 0 1.184-.822 2.122-2.14 2.122zM21 21h-3.978v-6.328c0-1.657-.623-2.786-1.991-2.786-1.047 0-1.629.762-1.9 1.498-.101.263-.085.63-.085 1V21H9.104s.051-11.21 0-12.228h3.942v1.919c.232-.84 1.492-2.037 3.502-2.037C19.04 8.654 21 10.414 21 14.2V21z"
			fillRule="evenodd"
		/>
	</svg>
)

export default LinkedIn
